import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: [],
};

const groupsForRoles = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_GROUPS_FOR_ROLE_BY_ID):
    case errorAction(types.GET_GROUPS_FOR_ROLE_BY_ID2):
      return {
        ...state,
        loading: false,
      };
    case successAction(types.GET_GROUPS_FOR_ROLE_BY_ID):
    case successAction(types.GET_GROUPS_FOR_ROLE_BY_ID2):
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    case requestAction(types.GET_GROUPS_FOR_ROLE_BY_ID):
    case requestAction(types.GET_GROUPS_FOR_ROLE_BY_ID2):
      return {
        ...state,
        data: [],
        loading: true,
      };
    default:
      return state;
  }
};

export default groupsForRoles;
